import { KnownOrderDtoStatus, KnownHistoricOrderStatsEventTypes } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Colors } from '../../ui/theme/colors';

// Dashboard stats refresh at most once per interval (polling and buffered SignalR invalidations)
export const STATS_REFRESH_INTERVAL_MS = 10 * 60 * 1000;

// The manual refresh button triggers at most one refresh per interval; extra clicks are ignored
export const MANUAL_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export const orderStatusCountCardSubtitleMap: Record<KnownOrderDtoStatus, string> = {
  booked: 'Awaiting staff delivery',
  delivered: 'Awaiting customer collection',
  'delivered-offline': 'Awaiting customer collection',
  overdue: 'Not collected on time',
  collected: 'Your customers have retrieved',
  cancelled: 'Never delivered to lockers',
  'in-progress': 'In progress',
  'retrieval-required': 'Awaiting staff retrieval',
  retrieved: 'Your staff have retrieved'
};

export const historicOrderStatsEventTypeToLabel: Record<KnownHistoricOrderStatsEventTypes, string> = {
  '*': 'All',
  bookings: 'Bookings',
  cancellations: 'Cancellations',
  collections: 'Collections',
  deliveries: 'Deliveries',
  retrievals: 'Retrievals'
};

export const eventTypeColors: Record<KnownHistoricOrderStatsEventTypes, string> = {
  '*': Colors.cardGray,
  bookings: Colors.bookedScannedInProgressGray,
  deliveries: Colors.deliveredBlue,
  collections: Colors.collectedGreen,
  cancellations: Colors.cancelledDeletedRed,
  retrievals: Colors.retrievedPurple
};
